import { useLayoutEffect } from './use-isomorphic-layout-effect';

/**
 *
 * @desc Locks the scroll of the given element
 * @param {*} selector - selector of the element to be locked
 *
 */
export default function useLockScroll(selector) {

    useLayoutEffect(() => {

        // Get element using the selector
        const element = document.querySelector(selector);

        // Check if element is document body
        const elementIsDocumentBody = element === document.body;

        // Get element scroll position
        const elementScrollPosition = !elementIsDocumentBody ? element.scrollTop : window.pageYOffset;

        // Prevent scrolling on mount
        element.style.position = 'fixed';
        element.style.top = `${-elementScrollPosition}px`;

        // Prevent mlb-react-header from conflicting with modal dialog if element is document body
        if(elementIsDocumentBody) {

            element.classList.remove('has-react-header');

        }

        // Re-enable scrolling when component unmounts
        return () => {

            const elementTopStyle = element.style.top;

            element.style.top = '';
            element.style.position = '';

            if(elementIsDocumentBody) {

                element.classList.add('has-react-header');

            }

            // Need to scroll back to element position b/c scroll position is lost when we use position fixed
            window.scrollTo(0, parseInt(elementTopStyle || '0') * -1);

        }

    }, []);

}
